import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import { ArticleView } from './types';

export const articlesApiUrl = '/Articles';

const ApiUrls = {
  articlesApiUrl
};

const GetArticleBySlug = (slug: string | undefined): Promise<ArticleView> =>
  nzApiAxios.get(ApiUrls.articlesApiUrl + `/${slug}`).then((response) => response.data);

const API = {
  getArticleBySlug: GetArticleBySlug
};

export { ApiUrls };
export default API;
